export enum BookingDayStatus {
	Active = 1,
	Sickness = 2,
	NoShow = 3,
	ClientCancelled = 4,
	ActOfGod = 5,
	PersonalAppt = 6,
	ClientIncident = 7,
	ClientClosures = 8,
	ClientRejected = 9,
	ClientStrike = 10,
	GeneralCancelled = 11,
	Duplicate = 12,
	NoTeacherAvailable = 13,
}
